import { BillingFrequency, Currency, formatBillingFrequency, formatDisplayPrice } from '@vendasta/shared';
import { Pipe, PipeTransform } from '@angular/core';
import { LineItem } from '@vendasta/sales-orders';

@Pipe({
  name: 'price',
  standalone: false,
})
export class PricePipe implements PipeTransform {
  transform(
    value: any,
    currency: Currency,
    billingFrequency?: BillingFrequency,
    isCents = true,
    translateZero = true,
    displaySymbol = true,
  ): any {
    return formatDisplayPrice(value, currency, billingFrequency, isCents, translateZero, displaySymbol);
  }
}

@Pipe({
  name: 'formatBillingFrequency',
  standalone: false,
})
export class FormatBillingFrequencyPipe implements PipeTransform {
  transform(value: string): string {
    return formatBillingFrequency(value);
  }
}

export function getTotalPriceForLineItems(lineItems: LineItem[]): number {
  return lineItems.reduce((total, lineItem) => {
    const liTotal = lineItem.currentRevenue.revenueComponents.reduce((rcTotal, revenueComponent) => {
      return rcTotal + (revenueComponent.value || 0);
    }, 0);
    return total + (liTotal || 0) * (lineItem.quantity || 1);
  }, 0);
}
